import { AnyAction, combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import tenancySlice from './slicers/tenancySlice';
import authenticationSlice from './slicers/authenticationSlice';
import areaSlice from './slicers/areaSlice';
import roomSlice from './slicers/roomSlice';
import eventsSlice from './slicers/eventsSlice';
import devicesSlice from './slicers/devicesSlice';
import zoneSlice from './slicers/zoneSlice';
import referenceSlice from './slicers/referenceSlice';
import trendsSlice from './slicers/trendsSlice';
import notificationsSlice from './slicers/notificationsSlice';

const combinedReducer = combineReducers({
	area: areaSlice.reducer,
	authentication: authenticationSlice.reducer,
	devices: devicesSlice.reducer,
	events: eventsSlice.reducer,
	room: roomSlice.reducer,
	notifications: notificationsSlice.reducer,
	tenancy: tenancySlice.reducer,
	reference: referenceSlice.reducer,
	zone: zoneSlice.reducer,
	trends: trendsSlice.reducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
	if (action.type === 'reset-state') {
		state = {} as RootState;
	}
	return combinedReducer(state, action);
};

const store = configureStore({
	reducer: rootReducer,
	devTools: process.env.NODE_ENV !== 'production',
	middleware(getDefaultMiddlewares) {
		if (process.env.NODE_ENV === 'production') {
			return getDefaultMiddlewares();
		} else {
			return getDefaultMiddlewares();
		}
	},
});

export type AppDispatch = typeof store.dispatch;
export default store;
